import React from 'react';
import "../../../../node_modules/ag-grid-community/styles/ag-grid.css";
import "../../../../node_modules/ag-grid-community/styles/ag-theme-quartz.css";
import { useImportData } from '../../../Hooks/Features/ImportData/useImportData';
import nodata from '../../../assets/nodata.jpg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from 'primereact/dropdown';
import DatePicker from 'react-multi-date-picker';



export const ImportData = () => {
    const { products, handleUpsertImportData, spinner, info, userOption, filterValue, setFilterValue } = useImportData();

    return (
        <div>
            <div className='row'>
                <div className='col-md-2 col-12'>
                    <Dropdown
                        placeholder="Users"
                        options={userOption}
                        optionLabel='user_display_name'
                        value={filterValue?.user}
                        onChange={(e) => setFilterValue((prev) => ({ ...prev, user: e.target.value }))}
                        filter
                        filterInputAutoFocus
                    />
                </div>
                <div className='col-md-3 col-12'>
                    <DatePicker
                        value={filterValue?.hoveredRange}
                        onChange={(e) => setFilterValue((prev) => ({ ...prev, hoveredRange: e }))}
                        range rangeHover
                        numberOfMonths={2}
                        placeholder="Select Dates"
                    />
                </div>
            </div>
            {products.length > 0 ? products?.map((btn) => (
                spinner[btn.api_key] ?
                    <span>
                        <button className="button btn-primary">
                            <div class="spinner-border" role="status" style={{ width: "19px", height: "20px" }}>
                                <span class="sr-only"></span>
                            </div>
                            <span style={{ fontSize: 'larger' }}>{btn.api_key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</span>
                        </button>&nbsp;
                    </span> :
                    <span>
                        <button key={btn.api_key} onClick={() => handleUpsertImportData(btn)}
                            className="button btn-primary"
                            title={btn.api_key}
                        >
                            <FontAwesomeIcon icon="fa-solid fa-download" />  <span style={{ fontSize: 'larger' }}>{btn.api_key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}</span>
                        </button>&nbsp;</span>
            )) : <div className='text-center'>
                <img src={nodata} alt="data not found" />
                <p className='text-center red mt-3'> Data Not Found</p>
            </div>}
            <div>
                {info.visible !== '' && (
                    <div style={{ textAlign: 'center', marginTop: '188px' }}>
                        <img src={info.visible === 'success' ? "./assets/success.png" : "./assets/error.png"} alt='no data' style={{ width: '10%' }} />
                        <div style={{ color: info.visible === 'success' ? 'green' : 'red', fontSize: '18px', marginTop: '10px' }}>
                            {info.message}
                        </div>
                    </div>
                )}

            </div>
        </div>

    )

}
export default ImportData;